export const MAX_DICTATION_SECONDS = 60

export const normalizeDictationLanguage = (language?: string) => {
  if (!language) return undefined

  return language.split('-')[0]?.toLowerCase() || undefined
}

export const appendTranscriptToText = (currentValue: string, transcript: string) => {
  const cleanedTranscript = transcript.trim()

  if (!cleanedTranscript) {
    return currentValue
  }

  const trimmedCurrentValue = currentValue.trimEnd()

  if (!trimmedCurrentValue) {
    return cleanedTranscript
  }

  return `${trimmedCurrentValue}\n${cleanedTranscript}`
}

export const formatDictationDuration = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}
